import type { FeatureFlags } from '@/services/types'
import { getFeatureFlagsService } from '@/core/container/ioc'

export const isFeatureEnabled = (featureFlag: FeatureFlags) => {
  return getFeatureFlagsService().isFeatureEnabled(featureFlag)
}
